var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00354004 3.3985L7.00092 6.89675L13.9983 3.3985C13.9724 2.95264 13.777 2.53355 13.4521 2.22707C13.1273 1.92059 12.6975 1.74992 12.2509 1.75H1.75092C1.3043 1.74992 0.874556 1.92059 0.549696 2.22707C0.224835 2.53355 0.0294436 2.95264 0.00354004 3.3985V3.3985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.35352L7 8.85351L0 5.35352V10.5003C0 10.9644 0.184374 11.4095 0.512563 11.7377C0.840752 12.0659 1.28587 12.2503 1.75 12.2503H12.25C12.7141 12.2503 13.1592 12.0659 13.4874 11.7377C13.8156 11.4095 14 10.9644 14 10.5003V5.35352Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c3361b70f6776382c0520e4db97f4103.svg";
export { ForwardRef as ReactComponent };